var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00089,
    cy: 8.99998,
    r: 6.99998,
    fill: "#DE1B69"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99999,
    cy: 2.99999,
    r: 2.99999,
    fill: "#DE1B69"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99999,
    cy: 15,
    r: 2.99999,
    fill: "#DE1B69"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0003,
    cy: 8.99999,
    r: 2.99999,
    transform: "rotate(90 15.0003 8.99999)",
    fill: "#DE1B69"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.00001,
    cy: 8.99999,
    r: 2.99999,
    transform: "rotate(90 3.00001 8.99999)",
    fill: "#DE1B69"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2429,
    cy: 13.2427,
    r: 2.99999,
    transform: "rotate(135 13.2429 13.2427)",
    fill: "#DE1B69"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.75762,
    cy: 4.75732,
    r: 2.99999,
    transform: "rotate(135 4.75762 4.75732)",
    fill: "#DE1B69"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.75818,
    cy: 13.2422,
    r: 2.99999,
    transform: "rotate(-135 4.75818 13.2422)",
    fill: "#DE1B69"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2435,
    cy: 4.75737,
    r: 2.99999,
    transform: "rotate(-135 13.2435 4.75737)",
    fill: "#DE1B69"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.74921,
    y: 10.25,
    width: 1.99999,
    height: 1.99999,
    rx: 0.999997,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.75012,
    y: 5.75049,
    width: 1.99999,
    height: 1.99999,
    rx: 0.999997,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62512 11.6255L11.6251 7.62548C11.9703 7.2803 11.9703 6.72066 11.6251 6.37549C11.2799 6.03031 10.7203 6.03031 10.3751 6.37549L6.37512 10.3755C6.02994 10.7206 6.02994 11.2803 6.37512 11.6255C6.7203 11.9706 7.27994 11.9706 7.62512 11.6255Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersIcon);
export default __webpack_public_path__ + "static/media/Offers_icon.684b6637d28d140d63b63f43d0fae268.svg";
export { ForwardRef as ReactComponent };